var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "missingEntriesModal",
            size: "xl",
            "content-class": "menu-bg-blue-transparent-modal",
            title: "Daily Productivity Report Missing Entries",
            "hide-footer": "",
            scrollable: "",
          },
          on: {
            show: function ($event) {
              return _vm.initMissingEntriesModal()
            },
          },
        },
        [
          _c("vue-bootstrap4-table", {
            attrs: {
              rows: _vm.missingRows,
              columns: _vm.missingColumns,
              config: _vm.config,
              classes: _vm.classes,
            },
            scopedSlots: _vm._u([
              {
                key: "Vehicles",
                fn: function (props) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(props.cell_value.join(", ")) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }